import BaseClient from './BaseClient';
import type { AxiosPromise } from 'axios';

interface OmniEmbedUrlResponse {
    url: string;
}

class OmniClient extends BaseClient {
    async getEmbedUrl(teamId: number): AxiosPromise<OmniEmbedUrlResponse> {
        const url = `/api/v3/teams/${teamId}/omni/embed-url`;
        return this.makeCoreApiRequest(url, 'get');
    }
}

export const omniClient = new OmniClient();
